import { PROFILE_ACTION_TYPES, PROFILE_FIELD_NAMES, PROFILE_SECTIONS } from './actionTypes';

const initialState = {
    activeSection: PROFILE_SECTIONS.PERSONAL_DATA,

    fields: {
        [PROFILE_FIELD_NAMES.LOGIN]: '',
        [PROFILE_FIELD_NAMES.DISPLAY_NAME]: '',

        [PROFILE_FIELD_NAMES.COUNTRY]: 'RU',
        [PROFILE_FIELD_NAMES.REGION]: '',
        [PROFILE_FIELD_NAMES.CITY]: '',
        [PROFILE_FIELD_NAMES.POSTAL_CODE]: '',
        [PROFILE_FIELD_NAMES.ADDRESS]: '',

        [PROFILE_FIELD_NAMES.FIRSTNAME]: '',
        [PROFILE_FIELD_NAMES.LASTNAME]: '',
        [PROFILE_FIELD_NAMES.PHONE_COUNTRY]: 'RU',
        [PROFILE_FIELD_NAMES.PHONE]: '',
        [PROFILE_FIELD_NAMES.EMAIL]: '',

        [PROFILE_FIELD_NAMES.IS_JURIDIC]: false,
        [PROFILE_FIELD_NAMES.COMPANY]: '',
        [PROFILE_FIELD_NAMES.COMPANY_INN]: '',
        [PROFILE_FIELD_NAMES.COMPANY_KPP]: '',
        [PROFILE_FIELD_NAMES.COMPANY_OGRN]: '',
        [PROFILE_FIELD_NAMES.COMPANY_CHIEF_NAME]: '',
        [PROFILE_FIELD_NAMES.COMPANY_CONTACT_NAME]: '',
        [PROFILE_FIELD_NAMES.COMPANY_JOB_TITLE]: '',
        [PROFILE_FIELD_NAMES.COMPANY_SCOPE]: '',
        [PROFILE_FIELD_NAMES.COMPANY_LEGAL_ADDR]: '',
        [PROFILE_FIELD_NAMES.COMPANY_POST_ADDR]: '',
    },

    originalFields: null,

    isSaving: false,
    isLoading: false,
    isChangingPassword: false,

    saveError: null,
    loadError: null,
    passwordError: null,

    saveSuccess: false,
    passwordChangeSuccess: false,

    orders: [],
    ordersLoading: false,
    ordersError: null,
    ordersPagination: { total: 0, totalPages: 1, page: 1, perPage: 10 },

    services: [],
    servicesLoading: false,
    servicesError: null,
    servicesPagination: { total: 0, totalPages: 1, page: 1, perPage: 10 },

    documents: [],
    documentsLoading: false,
    documentsError: null,
};

export const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_ACTION_TYPES.SET_ACTIVE_SECTION:
            return {
                ...state,
                activeSection: action.section,
            };

        case PROFILE_ACTION_TYPES.SET_PROFILE_FIELDS:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    ...action.data,
                },
                saveSuccess: false,
            };

        case PROFILE_ACTION_TYPES.SET_PROFILE_FIELD:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.fieldName]: action.value,
                },
                saveSuccess: false,
            };

        case PROFILE_ACTION_TYPES.RESET_PROFILE_FIELDS:
            return {
                ...state,
                fields: state.originalFields || initialState.fields,
                saveSuccess: false,
            };

        // Save Profile
        case PROFILE_ACTION_TYPES.REQUEST_SAVE_PROFILE:
            return {
                ...state,
                isSaving: true,
                saveError: null,
                saveSuccess: false,
            };

        case PROFILE_ACTION_TYPES.SAVE_PROFILE_SUCCESS:
            return {
                ...state,
                isSaving: false,
                saveSuccess: true,
                originalFields: { ...state.fields },
            };

        case PROFILE_ACTION_TYPES.SAVE_PROFILE_ERROR:
            return {
                ...state,
                isSaving: false,
                saveError: action.error,
            };

        // Load Profile
        case PROFILE_ACTION_TYPES.REQUEST_LOAD_PROFILE:
            return {
                ...state,
                isLoading: true,
                loadError: null,
            };

        case PROFILE_ACTION_TYPES.LOAD_PROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                fields: {
                    ...state.fields,
                    ...action.data,
                },
                originalFields: {
                    ...state.fields,
                    ...action.data,
                },
            };

        case PROFILE_ACTION_TYPES.LOAD_PROFILE_ERROR:
            return {
                ...state,
                isLoading: false,
                loadError: action.error,
            };

        // Change Password
        case PROFILE_ACTION_TYPES.REQUEST_CHANGE_PASSWORD:
            return {
                ...state,
                isChangingPassword: true,
                passwordError: null,
                passwordChangeSuccess: false,
            };

        case PROFILE_ACTION_TYPES.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isChangingPassword: false,
                passwordChangeSuccess: true,
            };

        case PROFILE_ACTION_TYPES.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                isChangingPassword: false,
                passwordError: action.error,
            };

        // Orders
        case PROFILE_ACTION_TYPES.REQUEST_ORDERS:
            return {
                ...state,
                ordersLoading: true,
                ordersError: null,
            };

        case PROFILE_ACTION_TYPES.RECEIVE_ORDERS:
            return {
                ...state,
                ordersLoading: false,
                orders: action.data,
                ordersPagination: action.pagination || state.ordersPagination,
            };

        case PROFILE_ACTION_TYPES.ORDERS_ERROR:
            return {
                ...state,
                ordersLoading: false,
                ordersError: action.error,
            };

        // Services
        case PROFILE_ACTION_TYPES.REQUEST_SERVICES:
            return {
                ...state,
                servicesLoading: true,
                servicesError: null,
            };

        case PROFILE_ACTION_TYPES.RECEIVE_SERVICES:
            return {
                ...state,
                servicesLoading: false,
                services: action.data,
                servicesPagination: action.pagination || state.servicesPagination,
            };

        case PROFILE_ACTION_TYPES.SERVICES_ERROR:
            return {
                ...state,
                servicesLoading: false,
                servicesError: action.error,
            };

        // Documents
        case PROFILE_ACTION_TYPES.REQUEST_DOCUMENTS:
            return {
                ...state,
                documentsLoading: true,
                documentsError: null,
            };

        case PROFILE_ACTION_TYPES.RECEIVE_DOCUMENTS:
            return {
                ...state,
                documentsLoading: false,
                documents: action.data,
            };

        case PROFILE_ACTION_TYPES.DOCUMENTS_ERROR:
            return {
                ...state,
                documentsLoading: false,
                documentsError: action.error,
            };

        default:
            return state;
    }
};
